module.exports = __webpack_public_path__ + "static/media/mt.d0ddc58b.webp";